<template>
    <v-container>
        <v-row>
            <v-col>

                <div class="headline">Aktivitetslogg</div>
                <span v-if="limited" :class="['error', 'ml-3', 'px-2']">MAX 300 AKTIVITETER. JUSTER SØKSPARAMETERE</span>

                <br>

                <div style="display: inline-flex; width: 100%">
                    <v-icon :color="searchType == 'days'? 'success':'grey'" :disabled="searchType !== 'days'">mdi-check-circle</v-icon>
                    <v-select v-model="days" :items="dayOptions" :disabled="activitiesLoading" label="Antall dager"></v-select>
                    <v-btn fab small @click="loadActivities({days: days})" :disabled="activitiesLoading" color="primary" class="ml-1">
                        <v-icon size="28" v-if="!activitiesLoading">mdi-magnify</v-icon>
                        <v-progress-circular indeterminate :size="28" v-if="activitiesLoading"></v-progress-circular>
                    </v-btn>
                </div>

                <v-row>
                    <v-col cols="12" sm="6">
                        <div style="display: inline-flex; width: 100%">
                            <v-icon :color="searchType == 'dates'? 'success':'grey'" :disabled="searchType !== 'dates'">mdi-check-circle</v-icon>

                            <v-menu v-model="showFrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-on="on" readonly ref="from" v-model="from" :disabled="activitiesLoading" label="fra" placeholder="YYYY-MM-DD" clearable :error-messages="dateErrors"></v-text-field>
                                </template>
                                <v-date-picker v-model="from" :first-day-of-week="1" @input="showFrom = false" :allowed-dates="allowedDates" :title-date-format="(x) => moment(x).format('ddd, D MMM')" :weekday-format="(x) => moment(x).format('dd')" :header-date-format="(x) => moment(x).format('MMM')" :month-format="(x) => moment(x).format('MMM')"></v-date-picker>
                            </v-menu>

                            <v-btn fab small color="primary" :disabled="!canSearch" @click="dateSearch" class="ml-1">
                                <v-icon v-if="!activitiesLoading" size="28">mdi-magnify</v-icon>
                                <v-progress-circular v-else indeterminate size="28"></v-progress-circular>
                            </v-btn>
                        </div>

                    </v-col>
                    <v-col cols="12" sm="6">
                        <div style="display: inline-flex; width: 100%">
                            <v-icon v-if="$vuetify.breakpoint.xsOnly" :color="searchType == 'dates'? 'success':'grey'" :disabled="searchType !== 'dates'" class="mr-1">mdi-check-circle</v-icon>

                            <v-menu v-model="showTo" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-on="on" readonly ref="to" v-model="to" :disabled="activitiesLoading" label="til" placeholder="YYYY-MM-DD" clearable :error-messages="dateErrors"></v-text-field>
                                </template>
                                <v-date-picker v-model="to" :first-day-of-week="1" @input="showTo = false" :allowed-dates="allowedDates" :title-date-format="(x) => moment(x).format('ddd, D MMM')" :weekday-format="(x) => moment(x).format('dd')" :header-date-format="(x) => moment(x).format('MMM')" :month-format="(x) => moment(x).format('MMM')"></v-date-picker>
                            </v-menu>

                            <v-btn fab small color="primary" :disabled="!canSearch" @click="dateSearch" class="ml-1">
                                <v-icon v-if="!activitiesLoading" size="28">mdi-magnify</v-icon>
                                <v-progress-circular v-else indeterminate size="28"></v-progress-circular>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>

                <v-data-table ref="activitiesTable" :headers="headers" :items="activities" :loading="activitiesLoading" :search="search" hide-default-footer :items-per-page="-1" :mobile-breakpoint=0>
                    <template v-slot:top={items}>
                        <v-row align="center" class="mx-2">
                            <v-col cols="12" sm="6">
                                <div class="body-1 font-weight-bold">{{items.length}} {{items.length == 1? 'aktivitet': 'aktiviteter'}} {{searchType === 'days'? `(${days} antall dager)`: `(fra ${from? from: 'begynnelsen'} til ${to? to: 'nå'})`}}</div>
                            </v-col>
                            <v-col col="12" offset-sm="1" sm=5>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="søk" clearable></v-text-field>
                            </v-col>
                        </v-row>

                    </template>
                    <template v-slot:item="{item}">
                        <tr :class="[activityColor(item)]" @click="openDelivery(item.delivery.id)" :style="{'cursor': item.source == 0?'pointer':'default', 'white-space': 'nowrap'}">
                            <td>
                                <v-icon>{{item? activityIcon(item) : ''}}</v-icon>
                            </td>
                            <td>{{reason(item)}}</td>
                            <td>{{gateName(item)}}</td>
                            <td>{{userName(item)}}</td>
                            <td>{{companyName(item)}}</td>
                            <td>{{deliveryName(item)}}</td>
                            <td>{{timestamp(item)}}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import moment from "moment";
// import axios from "axios";
export default {
    data() {
        return {
            activitiesLoading: false,
            activities: [],
            gates: [],
            companies: [],
            deliveries: [],
            days: 1,
            dayOptions: [1, 2, 3, 4, 5, 6, 7],
            headers: [
                { text: "type", sortable: false, width: "1%" },
                { text: "info", sortable: false, width: "2%" },
                { text: "port", value: "gate.name", width: "1%" },
                { text: "bruker", value: "user.name", width: "1%" },
                { text: "bedrift", value: "user.companyName", width: "1%" },
                { text: "leveranse", value: "delivery.name", width: "1%" },
                { text: "tidspunkt", value: "body.timestamp", width: "1%" }
            ],
            search: "",
            searchType: "",
            from: "",
            showFrom: false,
            to: "",
            showTo: false,
            limited: false,
            validDateFormats: ["YYYY-MM-DD", "YYYY-MM-D", "YYYY-M-DD", "YYYY-M-D", "YYYY-MM", "YYYY-M"],
            dateErrors: []
        };
    },
    computed: {
        // filteredActivities() {

        //     if(!this.$refs.activitiesTable || !this.$refs.activitiesTable.internalCurrentItems){
        //         return [];
        //     }

        //     return this.$refs.activitiesTable.internalCurrentItems;
        // },
        canSearch() {
            if ((this.$refs.from && this.$refs.from.hasError) || (this.$refs.to && this.$refs.to.hasError)) {
                return false;
            }

            // if (!this.from && !this.to) {
            //     this.loadActivities({ days: this.days });
            // }

            return (!!this.from || !!this.to) && !this.activitiesLoading;
        }
    },
    methods: {
        order() {
            if (this.from && this.to) {
                if (moment(this.from).isAfter(moment(this.to))) {
                    return "fra-dato må være lik eller mindre enn til-dato";
                }
            } else if (!this.from && !this.to) {
                return true;
            } else if (!this.from || !this.to) {
                return "ingen eller begge datoene må fylles ut";
            } else {
                return true;
            }

            return true;
        },
        allowedDates(val) {
            let date = moment(val);
            let today = moment();

            return !today.isSameOrBefore(date);
        },
        activityColor(activity) {
            if (activity.body && "reason" in activity.body) {
                if(activity?.body?.reason == 8){
                    return "blue lighten-3";
                }

                if ("openUnix" in activity.body && "openTimeoutUnix" in activity.body) {
                    if (activity.body.reason == 2 && activity.body.openUnix) {
                        return "green lighten-4";
                    }
                    // GRACE EARLY
                    if (activity.body.reason == 5 && activity.body.openUnix) {
                        return "green lighten-4";
                    }
                    // GRACE LATE
                    if (activity.body.reason == 6 && activity.body.openUnix) {
                        return "green lighten-4";
                    }
                    if (activity.body.reason == 2 && activity.body.openTimeoutUnix) {
                        return "red lighten-4";
                    }
                    if (activity.body.reason != 2) {
                        return "red lighten-2";
                    }
                } else {
                    if (activity.body.reason == 2) {
                        return "green lighten-4";
                    }
                    if (activity.body.reason != 2) {
                        return "red lighten-4";
                    }
                }
            }

            if (activity.body && "info" in activity.body && activity.body.info && (activity.body.info.includes("shutdown") || activity.body.info.includes("power"))) {
                return "orange lighten-4";
            }

            if (activity.body && "info" in activity.body && activity.body.info && activity.body.info.includes("startup")) {
                return "orange lighten-4";
            }
        },
        activityIcon(activity) {
            if(activity.body && activity.body.reason === 8){
                return "mdi-car-emergency"
            }

            if (activity.body && "info" in activity.body && activity.body.info && activity.body.info.includes("shutdown")) {
                return "mdi-alert";
            }

            if (activity.body && "info" in activity.body && activity.body.info && activity.body.info.includes("startup")) {
                return "mdi-battery-charging";
            }

            if (activity.body && "hash" in activity.body) {
                return "mdi-cellphone-arrow-down";
            }

            if (activity.body && "source" in activity.body) {
                if (activity.body.source == 0) {
                    return "mdi-truck";
                } else if (activity.body.source == 1) {
                    return "mdi-phone";
                } else if (activity.body.source == 2) {
                    return "mdi-bluetooth";
                } else {
                    return "mdi-help-circle"
                }
            } else {
                if (!activity.delivery) {
                    return "mdi-phone-missed";
                }

                if (activity.delivery.name) {
                    return "mdi-truck";
                } else {
                    return "mdi-phone";
                }
            }

            // return "http";
        },
        reason(activity) {
            if (activity.body && "info" in activity.body && activity.body.info && activity.body.info.includes("shutdown")) {
                return "strømbrudd";
            }

            if (activity.body && "info" in activity.body && activity.body.info && activity.body.info.includes("startup")) {
                return `oppstart ${activity.body.version ? "- ver." + activity.body.version : ""}`;
            }

            if (activity.body && "hash" in activity.body) {
                return "oppdater koder";
            }

            if (activity.body && "reason" in activity.body) {
                switch (activity.body.reason) {
                    case 0: {
                        if (activity.body.source == 0) {
                            return `ukjent levering med kode "${activity.body.info}"`;
                        } else {
                            return "ukjent telefonnummer";
                        }
                    }
                    case 1: {
                        return "for tidlig";
                    }
                    case 2: {
                        if ("openUnix" in activity.body && "openTimeoutUnix" in activity.body) {
                            if (activity.body.openUnix) {
                                return "i tiden og åpnet";
                            }
                            if (activity.body.openTimeoutUnix) {
                                return "i tiden men åpnet ikke";
                            }
                        }

                        return "i tiden";
                    }
                    case 3: {
                        return "for sent";
                    }
                    case 4: {
                        if (activity.body.source == 0) {
                            return `koden er brukt`;
                        } else {
                            return "ringetilgang er brukt";
                        }
                    }
                    case 5: {
                        return `for tidlig, men innen utvidet tidsperiode`;
                    }
                    case 6: {
                        return `for sent, men innen utvidet tidsperiode`;
                    }
                    case 7: {
                        return `Prosjekt er stengt`;
                    }
                    case 8: {
                        return `Etat åpnet porten`
                    }
                }
            }

            return "-";
        },
        gateName(row) {
            let gateName;
            let deliveryName;
            // {{props.item.gate.name}} {{!!props.item.delivery.zoneName ? `(${props.item.delivery.zoneName})`: ''}}
            if ("gate" in row) {
                gateName = row.gate.name;
            }

            if ("delivery" in row) {
                deliveryName = row.delivery.zoneName;
            }

            if (!gateName && !deliveryName) {
                return "-";
            }
            if (gateName && !deliveryName) {
                return gateName;
            } else {
                return `${gateName} - ${deliveryName}`;
            }
        },
        userName(row) {
            // {{props.item.user.name ? props.item.user.name : props.item.body.phoneNumber}}
            // debugger;
            if ("user" in row && row.user.name) {
                return row.user.name;
            } else if ("body" in row && "phoneNumber" in row.body && row.body.phoneNumber) {
                return row.body.phoneNumber;
            } else {
                return "-";
            }
        },
        companyName(row) {
            // {{props.item.user.companyName ? props.item.user.companyName : '-'}}
            if ("user" in row && row.user.companyName) {
                return row.user.companyName;
            } else if ("delivery" in row && row.delivery.supplierName) {
                return row.delivery.supplierName;
            } else {
                return "-";
            }
        },
        deliveryName(row) {
            // {{props.item.delivery.name ? props.item.delivery.name : '-'}}
            if ("delivery" in row && row.delivery.name) {
                return row.delivery.name;
            } else {
                return "-";
            }
        },
        timestamp(row) {
            // {{props.item.timestamp}}
            if ("timestamp" in row) {
                return row.timestamp;
            } else if ("unix" in row) {
                return moment.unix(row.unix).format("YYYY-MM-DD HH:mm:ss");
            } else if ("body" in row && "timestamp" in row.body) {
                if (isNaN(Number(row.body.timestamp))) {
                    return row.body.timestamp;
                } else {
                    return moment.unix(row.body.timestamp).format("YYYY-MM-DD HH:mm:ss");
                }
            } else {
                return "-";
            }
        },
        openDelivery(deliveryId) {
            if (deliveryId) {
                this.$router.push(`/delivery/details/${deliveryId}`);
            }
        },
        dateSearch() {
            if (!this.canSearch || this.activitiesLoading) {
                return;
            }

            this.loadActivities({
                start: this.from
                    ? moment(this.from, this.validDateFormats, true)
                          .startOf("day")
                          .unix()
                    : null,
                end: this.to
                    ? moment(this.to, this.validDateFormats, true)
                          .endOf("day")
                          .unix()
                    : null
            });
        },
        codeType: function(type) {
            switch (type.toLowerCase()) {
                case "entry":
                    return "inngang";
                case "exit":
                    return "utgang";
                default:
                    return "ukjent";
            }
        },
        loadActivities: function({ days, start, end }) {
            if (days && !start && !end) {
                this.searchType = "days";
            } else {
                this.searchType = "dates";
            }

            this.activitiesLoading = true;
            this.limited = false;
            // this.activities.splice(0);
            let _params = {};

            if (days) {
                _params.span = days;
                _params.from = moment()
                    .subtract(days - 1, "days")
                    .startOf("day")
                    .unix();
                _params.to = moment().unix();
            } else {
                if (start) {
                    _params.from = start;
                }
                if (end) {
                    _params.to = end;
                } else {
                    _params.to = moment().unix();
                }
            }

            // let accessActivities = [];

            this.axios
                .get("/activity/history", {
                    params: _params
                })
                .then(async response => {
                    let gates = [];
                    let companies = [];
                    let deliveries = [];

                    let activities = response.data.data.map(a => {
                        let timestamp;
                        if ("openUnix" in a && a.body.openUnix) {
                            // when gate was opened
                            timestamp = a.openUnix;
                        } else if ("timestamp" in a && a.body.timestamp) {
                            // when access code was created on the unit
                            timestamp = a.timestamp;
                        } else if ("unix" in a && a.unix) {
                            // when activity was uploaded on to the server
                            timestamp = a.unix;
                        } else {
                            // (same as above) when activity was uploaded on to the server
                            timestamp = a.created_at;
                        }

                        if (typeof timestamp == "string") {
                            a.timestamp = moment(timestamp);
                        } else {
                            a.timestamp = moment.unix(timestamp);
                        }

                        a.timestamp = a.timestamp.format("YYYY-MM-DD HH:mm:ss");
                        return a;
                    });

                    activities.forEach(a => {
                        let gateName = a.gate.name;

                        let gate = gates.find(g => g.name === gateName);
                        if (!gate) {
                            gates.push({ name: gateName, activityCount: 1 });
                        } else {
                            gate.activityCount++;
                        }

                        let companyName = a.user.companyName;
                        if (companyName) {
                            let company = companies.find(c => c.name === companyName);
                            if (!company) {
                                companies.push({
                                    name: companyName,
                                    activityCount: 1
                                });
                            } else {
                                company.activityCount++;
                            }
                        }

                        if (a.delivery.id) {
                            let delivery = !deliveries.find(d => d.id == a.delivery.id);

                            if (delivery) deliveries.push(a.delivery);
                        }
                    });

                    gates.sort((a, b) => {
                        if (a.activityCount < b.activityCount) return 1;
                        else if (a.activityCount > b.activityCount) return -1;
                        else return 0;
                    });
                    companies.sort((a, b) => {
                        if (a.activityCount < b.activityCount) return 1;
                        else if (a.activityCount > b.activityCount) return -1;
                        else return 0;
                    });

                    this.gates = gates;
                    this.companies = companies;
                    this.activities = activities;

                    await (async () => {
                        this.activitiesLoading = true;
                        let shutdowns = [];
                        await this.axios
                            .get("/activity/history/poweroutage", {
                                params: _params
                            })
                            .then(response => {
                                try {
                                    shutdowns = response.data.map(s => {
                                        s.body = JSON.parse(s.body);
                                        s.timestamp = moment.unix(s.unix).format("YYYY-MM-DD HH:mm:ss");
                                        return s;
                                    });

                                    let union = [...this.activities, ...shutdowns];

                                    union.sort((a, b) => {
                                        if (a.timestamp < b.timestamp) return 1;
                                        else if (a.timestamp > b.timestamp) return -1;
                                        else return 0;
                                    });

                                    this.activities = union;
                                } catch (err) {
                                    // console.log(err);
                                }
                            })
                            .finally(() => {
                                this.activitiesLoading = false;
                            });
                    })();

                    await (async () => {
                        this.activitiesLoading = true;
                        let startups = [];
                        await this.axios
                            .get("/activity/history/startup", {
                                params: _params
                            })
                            .then(response => {
                                try {
                                    startups = response.data.map(s => {
                                        s.body = JSON.parse(s.body);
                                        s.timestamp = moment.unix(s.unix).format("YYYY-MM-DD HH:mm:ss");
                                        return s;
                                    });

                                    let union = [...this.activities, ...startups];

                                    union.sort((a, b) => {
                                        if (a.timestamp < b.timestamp) return 1;
                                        else if (a.timestamp > b.timestamp) return -1;
                                        else return 0;
                                    });

                                    this.activities = union;
                                } catch (err) {
                                    // console.log(err);
                                }
                            })
                            .finally(() => {
                                this.activitiesLoading = false;
                            });
                    })();

                    this.deliveries = deliveries;
                })
                .catch(() => {
                    // console.log(err);
                })
                .finally(() => {
                    if (this.activities.length == 300) {
                        this.limited = true;
                    } else {
                        this.limited = false;
                    }
                    this.activitiesLoading = false;
                });
        }
    },
    watch: {
        days: function() {
            this.loadActivities({ days: this.days });
        },
        from: function() {
            this.dateErrors.splice(0);
            let result = this.order();
            if (result !== true) {
                this.dateErrors.push(result);
            }

            if (this.dateErrors && this.dateErrors.length == 0) {
                this.dateSearch();
            }
            // else {
            // this.loadActivities({ days: this.days });
            // }
        },
        to: function() {
            this.dateErrors.splice(0);
            let result = this.order();
            if (result !== true) {
                this.dateErrors.push(result);
            }

            if (this.dateErrors && this.dateErrors.length == 0) {
                this.dateSearch();
            }
            // else {
            // this.loadActivities({ days: this.days });
            // }
        }
    },
    mounted() {
        this.loadActivities({ days: this.days });
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss" scoped>
</style>
